export default "__VITE_ASSET__C0XBB7t2__"